import { format } from 'date-fns/esm';
import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'shards-react';

const AgentDetails = ({ agent, closeModal, deleteAgent }) => {
  return (
    <Modal
      className='col-md-8 col-lg-8'
      open={true}
      toggle={closeModal}
      modalClassName='modal'
      fade={true}
      role='dialog'
    >
      <ModalHeader className='bg-primary1 text-white'>
        Agent Details
      </ModalHeader>
      <ModalBody>
        <table className='table mb-0'>
          <thead className='bg-light'>
            <tr>
              <th scope='col' className='border-0'>
                Name
              </th>
              <th scope='col' className='border-0'>
                Uid
              </th>
              <th scope='col' className='border-0'>
                Email
              </th>
              <th scope='col' className='border-0'>
                Last Sign In
              </th>
              <th scope='col' className='border-0'>
                Created By
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='caption text-break'> {agent.displayName}</td>
              <td className='caption text-break'>{agent.uid}</td>
              <td className='caption text-break'>{agent.email}</td>
              <td className='caption'>
                {agent.lastSignIn &&
                  format(agent.lastSignIn.toDate(), 'dd MMM yyy hh:mm')}
              </td>
              <td className='caption'>{agent.createdBy.name}</td>
            </tr>
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter className='home-buttons d-flex w-100 justify-content-between p-2'>
        <Button
          theme='warning'
          onClick={() => {
            deleteAgent(agent);
            closeModal();
          }}
        >
          Delete
        </Button>
        <Button theme='danger' onClick={() => closeModal()}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AgentDetails;
